import React, { useMemo } from 'react';
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import ComponentPageHeader from '../../../Common/PageHeader/ComponentPageHeader';
import ComponentDefectCodeListTable from './Components';
import { exportToExcelData } from '../../../Common/PageHeader/helper';
import { RootState } from '../../../redux/rootState';

function ScreenDefectCodeList() {
  const { DefectCodeListData } = useSelector((state: RootState) => state.ListDefectCodeReducer);

  const excelData = useMemo(() => DefectCodeListData?.Data?.map((item) => {
    const transformedDataItems = {
      Code: item?.Code,
      Category: item?.Category,
      Sub_category: item?.SubCategory,
      Color: item?.Color,
      Description: item?.Description,
    };
    return transformedDataItems;
  }), [DefectCodeListData]);

  const downloadExcel = () => {
    exportToExcelData(
      {
        data: excelData,
      },
      'Defect_code_list',
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12}>
        <ComponentPageHeader subHeading="Defect Code" downloadExcel={downloadExcel} />
      </Grid>
      <div className="whiteSpace" />
      <Grid item xs={12} sm={12} md={12} className="dataTableCustomMargin">
        <ComponentDefectCodeListTable />
      </Grid>
    </Grid>
  );
}

export default ScreenDefectCodeList;
